import { useState, useEffect } from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { ToastAction } from "../../Redux/Actions/ToastAction";

import "./style.css";

import { IReduxState } from "../../utils/types";

import CJSCListing from "./components/CJSCListing";
import CreateNewCampaign from "./components/CreateNewCampaign";
import {
  getCJSCIdDropdownList,
  exportToCsv,
} from "../../Redux/Actions/CampaignsActions";
import HashModal, { HashButton } from "../Admin/HashModal";
import FeatherIcon from "feather-icons-react";
import EditCampaign from "./components/EditCampaign";
import { resumeCampaign, getAllCampaigns } from "../../Redux/Actions/CampaignsActions";

const Campaigns = () => {
  const [isPopUp, setIsPopUp] = useState(false);
  const [isEditPopUp, setIsEditPopUp] = useState(false);
  const [editModalData, setEditModalData] = useState<any>({});
  const [listingFilterCJSCID, setListingFilterCJSCID] = useState("");
  const [showHashModal, setShowHashModal] = useState(false);
  const [showAllChecked, setShowAllChecked] = useState(false);
  const handleCloseModal = () => setShowHashModal(false);
  const dispatch = useDispatch();

  const AuthState = useSelector((state: IReduxState) => state.Auth);
  const adminState = useSelector((state: IReduxState) => state.Auth);
  const CampaignsState = useSelector((state: IReduxState) => state.Campaigns);

  useEffect(() => {
    dispatch(getCJSCIdDropdownList());
  }, [dispatch]);

  const [cfscId_list, setCfscIdList] = useState<any[]>([]);

  useEffect(() => {
    if (CampaignsState?.cjsids_dropdown) {
      const updatedList = CampaignsState.cjsids_dropdown.map((obj: any) => ({
        ...obj,
        value: obj._id,
        label: `${obj.name}` /* | ${obj.email}`*/,
      }));
      
      setCfscIdList(updatedList);
    }
  }, [CampaignsState?.cjsids_dropdown]);

  let isDisplayCjscIdDropdown =
    (cfscId_list && cfscId_list.length > 1) 
    || AuthState.role.includes("admin")
      ? true
      : false;

  const togglecheck = () => {
    // console.log(CjsConfigState);
    if (CampaignsState.dailyLimitExceeded) {
      dispatch(
        ToastAction({
          message: `You have reached the daily campaigns limit, please try again tomorrow`,
          severity: "Danger",
          show: true,
        })
      );
      return;
    } else if (CampaignsState.monthlyLimitExceeded) {
      dispatch(
        ToastAction({
          message: `You have reached the monthly campaigns limit, please try again next month`,
          severity: "Danger",
          show: true,
        })
      );
    } else {
      setIsPopUp(true);
    }
  };

  let loggedInUser = cfscId_list.find((user: any) => user._id === AuthState.id);

  let defaultValueCjscID: any;
  let disableCJSCIDSelection: boolean = false;
  if (cfscId_list && cfscId_list.length <= 1) {
    defaultValueCjscID = cfscId_list[0];
    disableCJSCIDSelection = true;
  }
  let defaultCjscID: any = listingFilterCJSCID
    ? listingFilterCJSCID
    : defaultValueCjscID;


    const handleShowAllUsers = (event: { target: { checked: boolean } }) => {
      setCfscIdList([]);
    
      const isChecked = event.target.checked;
      setShowAllChecked(isChecked)
    
      if (isChecked) {
        if (AuthState?.subUsers) {
          const updatedList = AuthState.subUsers.map((obj: any) => ({
            ...obj,
            value: obj._id,
            label: `${obj.name}`,
          }));
          setCfscIdList(updatedList);
        }
      } else {
        if (CampaignsState?.cjsids_dropdown) {
          const updatedList = CampaignsState.cjsids_dropdown.map((obj: any) => ({
            ...obj,
            value: obj._id,
            label: `${obj.name}`,
          }));
          setCfscIdList(updatedList);
        }
      }
    
    };

    const isActive = editModalData?.status
    
  return (
    <>
    {showHashModal && <HashModal showHashModal={showHashModal} onClose={handleCloseModal}/>}
      <div style={isPopUp || isEditPopUp ? { display: "none" } : { color: "black" }}>
        <Row className="d-flex justify-content-center mt-3">
          <Row>
            <h3 className="module_title" style={{ paddingBottom: "0px" }}>
              Campaigns{" "}
              <p>
                Allows Ad URL association to selected "controlled ads".
                Advertisements can be either in applications or website.
              </p>{" "}
            </h3>
          </Row>
        </Row>
        <div
          className="Table-Box"
          style={isPopUp ? { visibility: "hidden" } : { color: "black" }}
        >
          <div className="Table-Box-Head">
            <p
              style={{
                fontSize: "15px",
                margin: "0",
                fontWeight: 600,
                textTransform: "uppercase",
              }}
            >
              ADS TESTER
            </p>

            <div>
            {adminState.show_hash &&
            // <Button
            //                   className="fsz-875rem mb-0 orange-btn NewCampagin align-items-center"
            //                   variant="warning"
            //                   onClick={() => {
            //                     setShowHashModal(true);
            //                   }}
            //                 >
            //                   <FeatherIcon icon='hash' size={17} style={{ verticalAlign: 'sub'}} /> User ID{" "}
            //                 </Button>
            <HashButton onClick={() => {setShowHashModal(true)}} className={'fsz-875rem mb-0 orange-btn NewCampagin align-items-center'}/>
}
              <Button
                className="NewCampagin fsz-875rem"
                variant="secondary"
                onClick={() => dispatch(exportToCsv(listingFilterCJSCID,showAllChecked))}
              >
                {" "}
                Export to CSV{" "}
              </Button>
              {(AuthState.cjsc_ip ||
                AuthState.cjsc_id ||
                AuthState.cjsc_fifo ||
                AuthState.cjsc_id_ip ||
                AuthState.cjsc_ip_without_id ||
                AuthState.cjsc_multi_ipid || 
                AuthState.cjsc_multi_ipnoid ||
                AuthState.cjsc_infinite_fifo
              ) && (
                <Button
                  variant="primary"
                  disabled={isPopUp}
                  onClick={() => togglecheck()}
                  className={
                    isPopUp ? "NewCampaginActive" : "NewCampagin fsz-875rem"
                  }
                >
                  <Plus color="white" size={20} fontWeight="700" /> New Campaign{" "}
                </Button>
              )}
            </div>
          </div>
          {isDisplayCjscIdDropdown && (
            <Row>
              <Col lg={3}>
                <Select
                  className="react-select react-select-container fsz-875rem"
                  classNamePrefix="react-select"
                  onChange={(e: any) => {
                    setListingFilterCJSCID(e);
                  }}
                  name="cjsc_id"
                  value={defaultCjscID}
                  isDisabled={disableCJSCIDSelection}
                  options={
                    disableCJSCIDSelection
                      ? cfscId_list
                      : [{ value: "", label: "All" }].concat(cfscId_list)
                  }
                  hideSelectedOptions={false}
                />
              </Col>
              {AuthState.role.includes("admin")&&(
              <Col style={{display:"flex"}}>
              <Form.Check
                  id="showAll"
                  name="showAll"
                  className="fsz-875rem mt-1"
                  onChange={handleShowAllUsers}
                />
                <Form.Label htmlFor="showAll" id="smallerFontSize" className="m-1">
                  Show All Users
                </Form.Label>
              </Col>
)}
            </Row>
          )}

          {!isPopUp && (
            <CJSCListing
              isAdmin={AuthState.role.includes("admin")}
              dispatch={dispatch}
              listingFilterCJSCID={listingFilterCJSCID}
              showAll={showAllChecked}
              isDisplayCjscIdDropdown={isDisplayCjscIdDropdown}
              defaultValueCjscID={defaultValueCjscID?.value}
              isEditPopUp={isEditPopUp}
              setIsEditPopUp={setIsEditPopUp}
              setEditModalData={setEditModalData}
            />
          )}
        </div>
      </div>
      {isPopUp && (
        <CreateNewCampaign
          dispatch={dispatch}
          setIsPopUp={setIsPopUp}
          cfscId_list={cfscId_list}
          isDisplayCjscIdDropdown={isDisplayCjscIdDropdown}
          // defaultCjscID={loggedInUser}
          disableCJSCIDSelection={disableCJSCIDSelection}
          countries={AuthState.countries}
          countries_type={AuthState.countries_type}
          oss={AuthState.oss}
          oss_type={AuthState.oss_type}
          browsers={AuthState.browsers}
          browsers_type={AuthState.browsers_type}
          loggedInUser={loggedInUser}
        />
      )}
      {isEditPopUp && (
      <EditCampaign
          // show={isEditModal}
          // onHide={() => setIsEditModal(false)}
          onClose={() => {
            if (isActive) {
            dispatch(resumeCampaign(editModalData.cjscName));
            dispatch(getAllCampaigns(listingFilterCJSCID ? listingFilterCJSCID?.valueOf : defaultValueCjscID, null))
            }
            setIsEditPopUp(false);
            
          }}
          modalData={editModalData}
          isAdmin={false} dispatch={dispatch} cfscId_list={cfscId_list} isDisplayCjscIdDropdown={false} disableCJSCIDSelection={undefined} countries={AuthState.countries} countries_type={AuthState.countries_type} oss={AuthState.oss} oss_type={AuthState.oss_type} browsers={AuthState.browsers} browsers_type={AuthState.browsers_type} loggedInUser={undefined}        // modifiedIPs={[]}        // onUpdate={handleUpdateCampaign}
        // handleSave={handleUpdateCampaign}
      />
            )}
      {/* {isPopUp && <CreateNewCampaign dispatch={dispatch} setIsPopUp={setIsPopUp} cfscId_list={cfscId_list} isDisplayCjscIdDropdown={isDisplayCjscIdDropdown} displayScriptField={AuthState?.cjsc_script} displayPandaField={AuthState?.panda} defaultCjscID={defaultCjscID} disableCJSCIDSelection={disableCJSCIDSelection} displayFifoField={AuthState?.cjsc_fifo?AuthState?.cjsc_fifo:false} /> } */}
    </>
  );
};

export default Campaigns;
